// import {
//   Paper,
//   Typography,
//   Box,
//   TextField,
//   Button,
//   Alert,
//   CircularProgress,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";

// const SearchSection = ({
//   orderId,
//   setOrderId,
//   handleSearch,
//   handleKeyPress,
//   loading,
//   error,
//   searched,
// }) => {
//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: { xs: 2, md: 3 },
//         mb: 4,
//         borderRadius: "12px",
//         border: "1px solid #e0e0e0",
//       }}
//     >
//       <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
//         <TextField
//           fullWidth
//           label="Invoice/Job No."
//           variant="outlined"
//           value={orderId}
//           onChange={(e) => setOrderId(e.target.value)}
//           onKeyPress={handleKeyPress}
//           placeholder="e.g., N2493849"
//           error={!!error && searched}
//           disabled={loading}
//           sx={{
//             "& .MuiOutlinedInput-root": {
//               borderRadius: "8px",
//               "&.Mui-focused fieldset": {
//                 borderColor: "primary.main",
//                 borderWidth: "2px",
//               },
//             },
//           }}
//         />
//         <Button
//           variant="contained"
//           size="large"
//           startIcon={
//             loading ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : (
//               <SearchIcon />
//             )
//           }
//           onClick={handleSearch}
//           disabled={loading}
//           sx={{
//             minWidth: 140,
//             height: 56,
//             borderRadius: "8px",
//             boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//             textTransform: "none",
//             fontWeight: "600",
//             fontSize: "1rem",
//           }}
//         >
//           <Typography
//             variant="button"
//             fontWeight="600"
//             sx={{ whiteSpace: "nowrap" }}
//           >
//             {loading ? "Tracking..." : "Track Order"}
//           </Typography>
//         </Button>
//       </Box>
//       {error && searched && (
//         <Alert severity="error" sx={{ mt: 2, borderRadius: "8px" }}>
//           {error}
//         </Alert>
//       )}
//     </Paper>
//   );
// };

// export default SearchSection;


import {
  Paper,
  Typography,
  Box,
  TextField,
  Button,
  Alert,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const SearchSection = ({
  orderId,
  setOrderId,
  handleSearch,
  handleKeyPress,
  loading,
  error,
  searched,
}) => {
  const handleClear = () => {
    setOrderId("");
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 3 },
        mb: 4,
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
      }}
    >
      <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
        <TextField
          fullWidth
          label="Invoice/Customer No."
          variant="outlined"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="e.g., N2493849"
          error={!!error && searched}
          disabled={loading}
          InputProps={{
            endAdornment: orderId && (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClear}
                  edge="end"
                  size="small"
                  disabled={loading}
                  sx={{ ml: -1 }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
            sx: {
              "& .MuiInputBase-input": {
                flex: 1,
              },
              "& .MuiInputAdornment-positionEnd": {
                marginLeft: "auto",
                marginRight: 0,
              },
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              "&.Mui-focused fieldset": {
                borderColor: "primary.main",
                borderWidth: "2px",
              },
            },
          }}
        />
        <Button
          variant="contained"
          size="large"
          startIcon={
            loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <SearchIcon />
            )
          }
          onClick={handleSearch}
          disabled={loading}
          sx={{
            minWidth: 140,
            height: 56,
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            textTransform: "none",
            fontWeight: "600",
            fontSize: "1rem",
          }}
        >
          <Typography
            variant="button"
            fontWeight="600"
            sx={{ whiteSpace: "nowrap" }}
          >
            {loading ? "Tracking..." : "Track Order"}
          </Typography>
        </Button>
      </Box>
      {error && searched && (
        <Alert severity="error" sx={{ mt: 2, borderRadius: "8px" }}>
          {error}
        </Alert>
      )}
    </Paper>
  );
};

export default SearchSection;